import { isArray, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Col, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { urlSlugify } from 'utils/helper';

const MultipleNutritions = ({ index, formikKey, values, setLocalValues }) => {
  const defaultUnits = {
    unit: '',
    name: '',
    dv: undefined,
    value: undefined,
  };

  const [nutritionData, setNutritionData] = useState([defaultUnits]);

  const handleLocalChange = (index, key, value) => {
    const updatedNutritionData = nutritionData?.map((item, i) => (i === index ? { ...item, [key]: value } : item));
    setNutritionData(updatedNutritionData);
  };

  const addNutrition = () => {
    setNutritionData([...nutritionData, { value: '', unit: '', dv: '' }]);
  };

  const deleteNutrition = (index) => {
    setNutritionData(nutritionData?.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!isEmpty(values) && isArray(values)) {
      setNutritionData(values);
    }
  }, [values]);

  useEffect(() => {
    setLocalValues((prev) => ({
      ...prev,
      [formikKey.value]: nutritionData,
    }));
  }, [nutritionData]);

  const vitaminsType = [
    'Vitamin A',
    'Vitamin C',
    'Vitamin D',
    'Vitamin E',
    'Vitamin K',
    'Vitamin B1',
    'Vitamin B2',
    'Vitamin B3',
    'Vitamin B5',
    'Vitamin B6',
    'Vitamin B7',
    'Vitamin B9',
    'Vitamin B12',
  ];

  const mineralsList = [
    'Calcium',
    'Phosphorus',
    'Chloride',
    'Magnesium',
    'Potassium',
    'Sodium',
    'Chromium',
    'Copper',
    'Fluoride',
    'Iodine',
    'Iron',
    'Manganese',
    'Selenium',
    'Zinc',
  ];

  return (
    <>
      <Label>
        {index}. {formikKey.label}
      </Label>
      <div className="card p-4 bg-light">
        <div className="card-body">
          {!isEmpty(nutritionData) &&
            nutritionData?.map((nutrition, index) => (
              <Row key={index} className="align-items-center mb-3">
                <Col md={2}>
                  <Label>{index + 1}.</Label>
                </Col>
                <Col md={10} className="d-flex justify-content-start">
                  <div className="d-flex align-items-center" style={{ gap: 20 }}>
                    <select
                      className="form-select"
                      value={nutrition?.name}
                      onChange={(e) => {
                        const inputValue = urlSlugify(e.target.value)?.replaceAll('-', '_');
                        handleLocalChange(index, 'name', inputValue);
                      }}>
                      <option value={''}>Select</option>

                      {formikKey.label === 'Vitamins'
                        ? vitaminsType?.map((e) => <option value={urlSlugify(e)?.replaceAll('-', '_')}>{e}</option>)
                        : formikKey.label === 'Minerals'
                        ? mineralsList?.map((e) => <option value={urlSlugify(e)?.replaceAll('-', '_')}>{e}</option>)
                        : ''}
                    </select>

                    {/* <Input
                      type="text"
                      placeholder="Name"
                      value={nutrition.name || ''}
                      onChange={(e) => handleLocalChange(index, 'name', e.target.value)}
                    /> */}
                    <input
                      className="form-control"
                      name={`vitamin_value_${nutrition?.value}`}
                      type="number"
                      placeholder="Value"
                      step="0.01"
                      max="99999"
                      value={nutrition.value}
                      onChange={(e) => {
                        const value = e.target.value;
                        const parsed = parseFloat(value);

                        // Allow empty input
                        if (value === '' || (parsed <= 99999 && /^\d{0,5}(\.\d{0,2})?$/.test(value))) {
                          handleLocalChange(index, 'value', value === '' ? '' : parsed);
                        }
                      }}
                    />

                    <select
                      className="form-select"
                      value={nutrition.unit}
                      onChange={(e) => handleLocalChange(index, 'unit', e.target.value)}>
                      <option value={''}>Select Unit</option>
                      <option value={'g'}>grams (g)</option>
                      <option value={'mg'}>milligrams (mg)</option>
                      <option value={'mcg'}>micrograms (mcg)</option>
                      <option value={'iu'}>International Units (IU)</option>
                    </select>

                    <InputGroup>
                      <input
                        className="form-control"
                        name={`vitamin_dv_${nutrition?.value}`}
                        type="number"
                        placeholder="DV"
                        step="0.01"
                        max="100"
                        value={nutrition.dv}
                        onChange={(e) => {
                          const value = e.target.value;
                          const parsed = parseFloat(value);

                          // Allow empty input
                          if (value === '' || (parsed <= 100 && /^\d{0,3}(\.\d{0,2})?$/.test(value))) {
                            handleLocalChange(index, 'dv', parsed);
                          }
                        }}
                      />
                      <InputGroupText>%</InputGroupText>
                    </InputGroup>
                    <Button color="danger" onClick={() => deleteNutrition(index)}>
                      Delete
                    </Button>
                  </div>
                </Col>
              </Row>
            ))}
          <Button color="primary" onClick={addNutrition} className="mt-3">
            Add {formikKey.label}
          </Button>
        </div>
      </div>
    </>
  );
};

export default MultipleNutritions;
